module.exports = __webpack_public_path__ + "static/media/PM55.a0a5c54c.png";